import type { FC } from 'react';
import { cn } from 'src/utils/cn';

type SeparatorProps = {
  error?: boolean;
  disabled?: boolean;
};

export const Separator: FC<SeparatorProps> = (props) => {
  return (
    <div
      className={cn(
        `
          h-[130%] w-px bg-foreground-surface-default
          legacy:bg-legacy-brand
        `,

        props.error &&
          `
            bg-foreground-support-error
            legacy:bg-legacy-error
          `,
        props.disabled &&
          `
            bg-foreground-surface-disabled
            legacy:bg-legacy-inactive
          `
      )}
    />
  );
};
